import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Timeline} from "gsap";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";
import {WinterHoardParsedGameData} from "../../server/data/IWinterHoardServerData";
/**
 * Created by jonas on 2020-11-19.
 */

export class BuffaloPickEndPresentation implements GameRoundPresentation{

    constructor() {    }

    getAnimation(data:ParsedServerData):Timeline | null {
        return  WinterHoardGameModuleConfig.freeSpinIntroView.getEndAnimation(<WinterHoardParsedGameData>data);
    }


}